import { useCallback, useState } from "react";
import { CLAVE, lee, guarda, loQueSePide, olvida } from "@/lib/energia.mjs";

/**
 * El check-in de energía del día. Devuelve `[valor, contesta, pide, borra]`.
 *
 * `sessionStorage` Y NO `localStorage`, a diferencia de las preferencias, y la diferencia es
 * la que importa: las preferencias describen cómo quiere ver la plataforma —eso dura— y esto
 * describe cómo viene hoy, que no dura ni debe. Al cerrar la pestaña desaparece, así que no
 * hay historial de estados de ánimo de un menor en ningún sitio.
 *
 * Se lee UNA vez al montar y no se vigila: si el alumno tiene dos pestañas abiertas y contesta
 * en una, la otra se entera al recargar. Sincronizarlas costaría un `storage` listener y una
 * suscripción viva para un dato que dura una tarde.
 */
export function useEnergia() {
  const [valor, setValor] = useState(() => {
    try { return lee(window.sessionStorage); } catch { return null; }
  });

  const contesta = useCallback((nuevo) => {
    try { guarda(window.sessionStorage, nuevo); } catch { /* sin almacén */ }
    setValor(nuevo);
  }, []);

  const borra = useCallback(() => {
    try { olvida(window.sessionStorage); } catch { /* sin almacén */ }
    setValor(null);
  }, []);

  return [valor, contesta, loQueSePide(valor), borra, CLAVE];
}
